// Generated by BUCKLESCRIPT VERSION 1.9.1, PLEASE EDIT WITH CARE
'use strict';

var Curry         = require("bs-platform/lib/js/curry.js");
var React         = require("react");
var ReasonReact   = require("reason-react/lib/js/src/reasonReact.js");
var Notifications = require("./notifications");

var component = ReasonReact.statelessComponent("NotificationItem");

function make(notification, onDelete, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("a", {
                  className: "no-underline underline-hover",
                  href: Notifications.githubUrl(notification)
                }, React.createElement("article", {
                      className: "dt w-100 bb b--black-05 pb2 mt2 mh2"
                    }, React.createElement("div", {
                          className: "dtc w2 w3-ns v-mid"
                        }, React.createElement("img", {
                              className: "ba b--black-10 db br2 w2 w3-ns h2 h3-ns",
                              alt: "avatar",
                              src: notification[/* repository */5][/* owner */5][/* avatar_url */3]
                            })), React.createElement("div", {
                          className: "dtc v-mid pl3"
                        }, React.createElement("h1", {
                              className: "f6 f5-ns fw6 lh-title purple mv0"
                            }, notification[/* subject */4][/* title */0]), React.createElement("h2", {
                              className: "f6 fw4 mt0 mb0 light-purple"
                            }, notification[/* repository */5][/* full_name */0])), React.createElement("div", {
                          className: "dtc v-mid"
                        }, React.createElement("div", {
                              className: "w-100 tr"
                            }, React.createElement("button", {
                                  className: "f6 button-reset bg-white ba b--black-10 dim pointer pv1 black-60",
                                  onClick: (function (e) {
                                      e.preventDefault();
                                      return Curry._1(onDelete, notification);
                                    })
                                }, "Mark as read")))));
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/notificationItem.re
// module id = 101
// module chunks = 0